import * as React from "react";
import ReactTable from "react-table";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";
import { obtenerEstado } from "../modelo/Estado";
import { obtenerCausal } from "../modelo/Causal";
import { FiltroEmpresasTraslado, RespuestaEmpresasTraslado } from "../modelo/GestionEmpresasModelo";
import { Glyphicon } from "react-bootstrap";


export default class TablaEmpresasTraslado extends React.Component<TablaEmpresasTrasladoProps, any> {

    columns = [{
        id: "dniEmpleador",
        Header: "dni Empleador",
        accessor: "dniEmpleador",
        width: 90
    }, {
        id: "esComercial",
        Header: "Canal",
        accessor: "esComercial",
        width: 70
    }, {
        id: "mensajeEnvioSAT",
        Header: "Envio SAT",
        accessor: "mensajeEnvioSAT",
        Cell: props => this.renderDetalleJson(props, props.original.mensajeEnvioSAT, "Mensaje Traslado"),
        width: 65
    }, {
        id: "mensajeRespuestaSAT",
        Header: "R.Traslado",
        accessor: "mensajeRespuestaSAT",
        Cell: props => this.renderDetalleJson(props, props.original.mensajeRespuestaSAT, "Respuesta Traslado"),
        width: 65
    }, {
        id: "mensajeRespuestaMoraSAT",
        Header: "R.Mora",
        accessor: "mensajeRespuestaMoraSAT",
        Cell: props => this.renderDetalleJson(props, props.original.mensajeRespuestaMoraSAT, "Respuesta Mora"),
        width: 55
    }, {
        id: "empresTrasladable",
        Header: "Trasladable",
        accessor: "empresTrasladable",
        width: 70
    }, {
        id: "causal",
        Header: "Causal",
        accessor: "causal",
        Cell: props => this.renderCausal(props.original.causal),
        width: 150
    }, {
        id: "tipoExcepcion",
        Header: "Excepcion",
        accessor: "tipoExcepcion",
        width: 85
    }, {
        id: "arlAfiliacion",
        Header: "ARL Afiliacion",
        accessor: "arlAfiliacion",
        width: 85
    }, {
        id: "respuestaSURA",
        Header: "Respuesta",
        accessor: "respuestaSURA",
        Cell: props => this.renderDetalleJson(props, props.original.respuestaSURA, "Respuesta SURA"),
        width: 65
    }, {
        id: "estado",
        Header: "Estado",
        accessor: "estado",
        width: 90
    }, {
        id: "fechaProceso",
        Header: "Fecha Proceso",
        accessor: "fechaProceso",
        width: 150
    }, {
        id: "consecutivo",
        Header: "Seleccionar",
        accessor: "consecutivo",
        Cell: props => (this.renderEstadoGlosa(props)),
        width: 70
    }];

    render() {
        const { respuestasTSAT, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (respuestasTSAT.length < tamanoPagina) {
            numRegistros = respuestasTSAT.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{respuestasTSAT.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={respuestasTSAT}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroEmpresas: FiltroEmpresasTraslado = {
            dniEmpleador: this.props.filtro.dniEmpleador,
            fechaInicial: this.props.filtro.fechaInicial,
            fechaFinal: this.props.filtro.fechaFinal,
            causal: this.props.filtro.causal,
            excepcionado: this.props.filtro.excepcionado,
            estado: this.props.filtro.estado,
            canalIngreso: this.props.filtro.canalIngreso,
            dniProceso: this.props.filtro.dniProceso,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroEmpresas);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderCausal(codigoCausal: number) {
        return Number.isInteger(codigoCausal) ? obtenerCausal(codigoCausal).textoCausal : "";
    }

    renderDetalleJson = (props: any, stringJson: string, titulo: string) => {
        const subTitulo = `Consecutivo Proceso: # ${props.original.consecutivo}`;
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={titulo}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }

    renderEstadoGlosa = (props: any) => {
        if (props.original.pendiente) {
            return this.renderEstadoIcono("transfer");
        }

        const estado = obtenerEstado(props.original.estado);
        switch (estado.codigoEstado) {
            case 0:
            case 2:
            case 1:
                return (
                    this.renderCheckBox(props)
                );
            case 3:
                return (
                    this.renderEstadoIcono("ok")
                );
            default:
                return (
                    this.renderEstadoIcono("ban-circle")
                );
        }
    }

    renderEstadoIcono(icono: string) {
        return (
            <span className="icons-table">
                <Glyphicon glyph={icono} />
            </span>
        );
    }

    renderCheckBox = (props: any) => {
        return (
            <div className={"text-center"}>
                <input type="checkbox"
                    className={"checkbox-center"}
                    onChange={() => this.seleccionarFila(props.original)} />
            </div>
        );

    }

    seleccionarFila(respuesta: RespuestaEmpresasTraslado) {
        this.props.ingresarConsecutivo(respuesta.consecutivo);
    }
}

interface TablaEmpresasTrasladoProps {
    respuestasTSAT: Array<RespuestaEmpresasTraslado>
    filtro: FiltroEmpresasTraslado,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada: (filtro: FiltroEmpresasTraslado) => void,
    ingresarConsecutivo: (consecutivos: number) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/componentes/TablaEmpresasTraslado.tsx